import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom";
import Constants from "../../utils/constants"
import PageLoader from '../../components/loader';
import Header from '../../components/header'
import { ShiftsUIWrapper } from './style'
import { getshifts, getAllShifts, getLoading } from "./shiftsSlice";
import { setCurrentShiftData } from "../ShiftDetails/shiftDetailsSlice";
import { getSelectedDepartment, getDepartments, setCurrentDepartment } from '../DepartmentList/departmentsSlice';
import { Container, List, ListItemButton, ListItemText, Divider } from '../../utils/ui';
import { getLocalData } from '../../services/storageManager';


export default function ShiftList() {
    const { PAGE_HEADER } = Constants;
    const shiftList = useSelector(getshifts);
    const department = useSelector(getSelectedDepartment);
    let departmentList = useSelector(getDepartments);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isLoading = useSelector(getLoading);
    const [value, setValue] = React.useState(department);

    const handleDepartmentChange = (event) => {
        setValue(event.target.value);
        dispatch(setCurrentDepartment(event.target.value));
    };

    /**Select Shift */
    const handleShiftSelection = (shift) => {
        const selectedShiftId = shift.id;
        dispatch(setCurrentShiftData(shift));
        navigate(`${Constants.ROUTES.SHIFT_LIST}/${selectedShiftId}`)
    }

    /**Get Shift/task List */
    useEffect(() => {
        dispatch(getAllShifts({ selectedDept: value }))
    }, [dispatch]);

    useEffect(() => {
        dispatch(getAllShifts({ selectedDept: value }))
    }, [dispatch, value]);

    const listItemStyle = {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 500,
        fontSize: 18
    }

    return (
        <>
            {isLoading ? <PageLoader /> : ''}
            <Header
                dropDownList={departmentList}
                inputLabel={PAGE_HEADER.SELECT_DEPT}
                dropDownvalue={value}
                handleDropDownChange={handleDepartmentChange}
            />
            <Container  sx={{ pb: 10 }}>
                <ShiftsUIWrapper>
                    <div className='pageHeader'>{PAGE_HEADER.SELECT_SHIFT}</div>
                    <List component="nav" aria-label="Check List" >
                        {
                            shiftList.map((shift, index) => {
                                const isCurrentDate = new Date(Number(shift.due_date)).toDateString() === new Date().toDateString();

                                return isCurrentDate ? (
                                    <>
                                        <ListItemButton 
                                            onClick={() => handleShiftSelection(shift)}
                                        >
                                            <ListItemText primary={`${index + 1}. ${shift.name}`} secondary={`  ${!shift.due_date ? "No Due Date" : new Date(Number(shift.due_date)).toLocaleString()}`} primaryTypographyProps={{ style: listItemStyle }} />
                                        </ListItemButton>

                                    </>
                                ): null;
                            }
                            )
                        }
                    </List>
                </ShiftsUIWrapper>
            </Container>
        </>
    )
}